import { apiRequest } from '@/lib/httpClient'
import type {
  ProjectStatusDeletePayload,
  ProjectStatusListResponse,
  ProjectStatusUpsertPayload,
} from '@/types/projectStatus'

export async function fetchProjectStatus(clientId: string) {
  return apiRequest<ProjectStatusListResponse>('ui/projectstatus/List', {
    method: 'GET',
    open: true,
    query: { clientId },
  })
}

export async function upsertProjectStatus(payload: ProjectStatusUpsertPayload) {
  return apiRequest('projectStatus/ui/upsert', {
    method: 'POST',
    body: payload,
  })
}

export async function deleteProjectStatus(payload: ProjectStatusDeletePayload) {
  return apiRequest('projectStatus/ui/delete', {
    method: 'POST',
    body: payload,
  })
}
